export default __webpack_public_path__ + "locales/ko-KR/DataReassignmentDialog.json?hash=c3937c0a4c39444b6f927495151e37d7";